export default __webpack_public_path__ + "static/media/Cancel.e5617937.svg";